export default function useTripSelection({ renderAssignmentCards, renderCurrentSelection, setAssignmentOpenState, workspaceStore }) {
  return {
    selectAssignment(assignmentId) {
      const state = workspaceStore.getState();
      if (!state || !assignmentId) {
        return;
      }

      const assignment = state.assignmentsById.get(assignmentId);
      if (!assignment) {
        return;
      }

      const currentTrip = state.currentAssignment?.truck_id === assignmentId
        ? state.currentTrip || null
        : null;
      const trip = currentTrip
        || (Array.isArray(assignment.trips) && assignment.trips.length
          ? assignment.trips[0]
          : null);
      renderCurrentSelection(assignment, trip);
    },

    toggleAssignmentOpen(assignmentId) {
      const state = workspaceStore.getState();
      if (!state || !assignmentId || typeof setAssignmentOpenState !== "function") {
        return;
      }

      setAssignmentOpenState(state, assignmentId, !state.openTruckIds.has(assignmentId));
      renderAssignmentCards();
    },
  };
}